import React, {Component} from 'react';
import UndoRedo from './UndoRedo';


class ActionsBar extends Component {
    render() {
        return(
            <div id="bottomBar">
                <UndoRedo/>
                {this.props.children}
            </div>
        )
    }
}

export default ActionsBar;



// WEBPACK FOOTER //
// ./src/WorkingSpace/ActionsBar.js